import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_FR: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Entraînements',
  components_header_media_1: 'Pour hommes',
  components_header_media_2: 'Pour femmes',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Entraînez-vous plus intelligemment, sentez-vous mieux.',
  hero_button_text: 'Commencez dès maintenant',
  components_ressources_subheader_text: 'Guides et conseils',
  components_ressources_span_text: 'Combine la profondeur du yoga, la précision contrôlée du Pilates et le défi dynamique de la musculation pour favoriser un mode de vie sain et équilibré.',
  components_ressources_card_1_title: 'Conseils de yoga',
  components_ressources_card_1_text: 'Guide rapide pour un meilleur équilibre, une meilleure respiration et une meilleure fluidité.',
  components_ressources_card_2_title: 'Conseils de Pilates',
  components_ressources_card_2_text: 'Des conseils simples pour renforcer vos muscles abdominaux et améliorer votre contrôle.',
  components_notes_and_google_title_1: 'Développer sa force',
  components_notes_and_google_title_2: 'Yoga Tranquillité',
  components_notes_and_google_title_3: 'Pilates pour les abdominaux',
  media_content_section_multi_1_subheader_text: 'Vidéos d\'entraînements',
  media_content_section_multi_2_subheader_text: 'Vidéos de Yoga',
  media_content_section_multi_3_subheader_text: 'Vidéos de Pilates',
  text_media_1: 'Hommes',
  text_media_2: 'Femmes',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Dos',
  page_media_content_menu_chest: 'Poitrine',
  page_media_content_menu_legs: 'Jambes',
  page_media_content_menu_shoulders: 'Épaules',
  page_media_content_menu_abdominals: 'Abdominaux',
  components_text1_subheader_text: 'Une alimentation saine pour une vie active',
  components_text1_span_text: 'Des recettes saines qui soutiennent votre entraînement et améliorent votre bien-être.',
  components_footer_text: 'Renforcez votre corps, équilibrez votre esprit et bougez avec sens – votre espace pour la salle de sport, le yoga et le pilates.',
};